<template>
  <v-card flat>
    <v-card-title>
      Список экспертов банков ТЗ
    </v-card-title>
    <v-card-text>
      <v-data-table
          :headers="headers"
          :items="expertInfo"
          :items-per-page="10"
          class="stripped"
          no-data-text="Нет данных"
      >
        <template #top>
          <v-toolbar flat dense>
            <data-table-filter
                v-if="filters !== null && Object.keys(enabledFilters).length > 0"
                :value="enabledFilters"
                @input="filtersChange"
            />
            <div style="width: 5px" />
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn
                    color="primary"
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    @click="downloadExcel">
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>
              </template>
              Скачать таблицу
            </v-tooltip>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { dbMixin } from "@/mixins"
import { saveAs } from 'file-saver'
import DataTableFilter from "@/components/common/DataTableFilter"

export default {
  name: "BankExpertPage",
  components: { DataTableFilter },
  mixins: [dbMixin],
  data () {
    return {
      filters: {
        surname: {
          value: '',
          label: 'Фамилия',
          type: 'text'
        },
        firstname: {
          value: '',
          label: 'Имя',
          type: 'text'
        },
        patronymic: {
          value: '',
          label: 'Отчество',
          type: 'text'
        }
      },
      headers: [{
        value: 'organization.name',
        text: 'Наименование организации, рекомендовавшей эксперта',
        width: '80px'
      },
        {
          value: 'surname',
          text: 'Фамилия',
          width: '60px'
        },
        {
          value: 'firstname',
          text: 'Имя',
          width: '40px'
        },
        {
          value: 'patronymic',
          text: 'Отчество',
          width: '40px'
        },
        {
          value: 'position',
          text: 'Должность',
          width: '60px'
        },
        {
          value: 'degree',
          text: 'Учёная степень, звание (при наличии)',
          width: '60px'
        },
        {
          value: 'exerciseSolvability',
          text: 'Решаемость заданий',
          width: '40px'
        },
        {
          value: 'repExamIssues',
          text: 'Замечания из РЭ',
          width: '35px'
        },
        {
          value: 'actuality',
          text: 'Актуальность, корректность, пригодность заданий',
          width: '40px'
        },
        {
          value: 'specialities',
          text: 'Специальности',
          width: '60px'
        },
        {
          value: 'phone',
          text: 'Контактный телефон (для мобильной связи)',
          width: '60px'
        },
        {
          value: 'email',
          text: 'Адрес электронной почты (актуальный)',
          width: '60px'
        }],

      expertInfo: []
    }
  },
  computed: {
    enabledFilters () {
      const filters = {}
      let key
      for (key in this.filters) {
        if (this.filters[key].type !== 'hidden') {
          filters[key] = this.filters[key]
        }
      }
      return filters
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      this.expertInfo = []
      const url = `${process.env.VUE_APP_SERVER_URL}/roles/bank_expert?`
      let params = {}
      if (Object.keys(this.enabledFilters).length > 0) {
        Object.keys(this.filters).forEach(key => {
          params[key] = this.filters[key].value
        });
      }
      let response = await fetch(url + new URLSearchParams(params));
      if (response.ok) { // если HTTP-статус в диапазоне 200-299
        // получаем тело ответа (см. про этот метод ниже)
        let items = await response.json();
        items.forEach((el) => {
          el = this.convertKeysToCamelCase(el)
          el.organization = { id: el.orgId, name: el.orgName }
          // el.speciality = { id: el.specId, name: el.specName }
          this.expertInfo.push(el)
        })
      } else {
        alert("Ошибка HTTP: " + response.status);
      }
    },
    filtersChange (data) {
      for (const item in data) {
        // eslint-disable-next-line vue/no-mutating-props
        this.filters[item].value = data[item].value
      }
      this.fetchData()

    },
    async downloadExcel () {
      const url = `${process.env.VUE_APP_SERVER_URL}/excel/bank_expert`
      saveAs(url, 'Эксперты банков ТЗ.xlsx')
    }
  }
}
</script>

<style scoped>

</style>